import api from './client.js'

/* MIDI-mappings server-side. scope = kempenvision | imagecompo | tournaments.
   Device-ids blijven lokaal (per machine), alleen model + mappings reizen mee. */
export const midiConfigAPI = {
  get:    (scope)         => api.get(`/midi-config/${scope}`),
  put:    (scope, data)   => api.put(`/midi-config/${scope}`, data),
  reset:  (scope)         => api.delete(`/midi-config/${scope}`),
}
